import Components from "slotworks/components/components";
import gameState from "slotworks/model/game-state";
import slotDefinition from "slotworks/model/slot-definition";
import { convertToSingleSymbolReels, convertToReelsGrid } from "utils/reel-conversions";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";

class ChangeMatrixCommand {

    public trigger(scene: string) {

        Components.matrix.hold();

        lightningBorderAnimationUtil.stop();

        const reelset = slotDefinition.reelsets.get(this.getReelsetName(scene));
        const stops = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        Components.matrix.change(scene, this.getMatrixGrid(scene), stops, reelset);
        Components.matrix.jumpToGrid(this.getVisibleSymbols(scene));

        this.activateLightningBorder(scene);
    }

    private activateLightningBorder(scene: string) {
        if (this.isMultireelMatrix(scene)) {
            lightningBorderAnimationUtil.useBonusLightningBorder();
        } else {
            lightningBorderAnimationUtil.useBaseLightningBorder();
        }
    }

    private getReelsetName(scene: string) {
        return this.isMultireelMatrix(scene) ? "multireel" : "base";
    }

    private getVisibleSymbols(scene: string) {

        let spinRecord = gameState.getCurrentGame().getRootRecord() as SpinRecord;

        if (scene === "default") {
            spinRecord = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;
        }

        if (this.isMultireelMatrix(scene)) {
            return convertToSingleSymbolReels(spinRecord.grid);
        } else {
            return convertToReelsGrid(spinRecord.grid);
        }
    }

    private getMatrixGrid(scene: string) {
        return this.isMultireelMatrix(scene) ? [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1] : slotDefinition.matrixGrid;
    }

    private isMultireelMatrix(scene: string) {
        return scene === "multireel";
    }
}

export default new ChangeMatrixCommand();
